import { render } from "./Electric.vue?vue&type=template&id=2d793ca4"
import script from "./Electric.vue?vue&type=script&lang=js"
export * from "./Electric.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/Icons/Electric.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d793ca4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d793ca4', __exports__)) {
    api.reload('2d793ca4', __exports__)
  }
  
  module.hot.accept("./Electric.vue?vue&type=template&id=2d793ca4", () => {
    api.rerender('2d793ca4', render)
  })

}


export default __exports__